import "../../../assets/css/Compliance_LF/ComplianceAuditorScreen.css";
import { Link, useLoaderData } from "react-router-dom";
import { GridWrapper } from "../../../integrations/UoE-Grid/GridWrapper";
import { useApi } from "../../../Providers/ApiProvider";
import { useEffect, useState } from "react";
import GridContent from "../../../integrations/UoE-Grid/GridContent";
import { Logging } from "../../../Logging";
import { MessageBar } from "@fluentui/react";

type cachedEdocsDump = {
  edocspgnoOWSTEXT: string;
  edocsUCASNoOWSTEXT: string;
  esfpridOWSTEXT: string;
  OriginalPath: string;
  FileType: string;
  Title: string;
  Path: string;
  SPWebUrl: string;
  ParentLink: string;
  Created: string;
  Size: string;
  CreatedBy: string;
  IdentitySiteCollectionId: string;
  IdentityListId: string;
  IdentityListItemId: string;
  ContentType: string;
  UploadedByOWSTEXT: string;
  RegistryOnlyFileOWSBOOL: string;
  IncludeforTier4AuditOWSBOOL: string;
  DocumentTypeOWSCHCS: string;
  ResultTypeIdList: string;
  ResultTypeId: string;
  RenderTemplateId: string;
  piSearchResultId: string;
  DocId: string;
  Rank: string;
  GeoLocationSource: string;
  SiteId: string;
  UniqueId: string;
  WebId: string;
  contentclass: string;
  IsExternalContent: string;
  ListId: string;
  IdentityWebId: string;
};

type cachedEdocsDisplay = {
  Source_System: string;
  Document_Type: string;
  Filename: string;
  Filename_LINK: string;
  Uploaded_By: string;
  Created_Date: string;
  Size: string;
};

export function ComplianceEmergencyAuditorScreen() {
  let loaderData: any = useLoaderData();
  let api = useApi();
  const URL = document.URL.toLowerCase();
  let [StuName, setStuName] = useState<string>();
  let [cachedDocs, setCachedDocs] = useState<cachedEdocsDisplay[]>([]);

  // Get the cached docs and mutilate them into a nice display format
  useEffect(() => {
    api.General.get(
      "/sproc",
      JSON.stringify({
        sproc: "sputilities.webui.Comply_studocs_EmergencyCacheLookup",
        params: ["@PRID", loaderData.ident],
      }),
    ).then((resp) => {
      for (let index = 0; index < resp[0].length; index++) {
        let md = resp[0][index].MetadataJsonDump;
        let docMd: cachedEdocsDump = JSON.parse(md);

        let srcSystem = "Student Files";
        if (docMd.Path.includes("UGEAF")) {
          srcSystem = "Undergraduate Applicant Files";
        }
        if (docMd.Path.includes("PGEAF")) {
          srcSystem = "Postgraduate Applicant Files";
        }

        let contentType = docMd.ContentType.substring(
          docMd.ContentType.lastIndexOf("\n"),
        );
        let uploader = docMd.UploadedByOWSTEXT;
        if (uploader == "") {
          uploader = docMd.CreatedBy;
        }

        let disp: cachedEdocsDisplay = {
          Source_System: srcSystem,
          Document_Type: contentType,
          Filename: docMd.Title,
          Filename_LINK: docMd.Path,
          Uploaded_By: uploader,
          Created_Date: docMd.Created,
          Size: docMd.Size,
        };

        setCachedDocs((old) => {
          return [...old, disp];
        });
      }
    });
  }, []);

  useEffect(() => {
    api.General.get(
      "/sproc",
      JSON.stringify({
        sproc: "sputilities.webui.Comply_studata_TitleName",
        params: ["@PRID", loaderData.ident],
      }),
    ).then((resp) => {
      setStuName(resp[0][0].Name);
    });
  }, []);

  return (
    <div className="CAS_Container">
      <div className="CAS_Row">
        <h1 className="CAS_PageTitle">
          Audit Information for <strong>{StuName}</strong>
        </h1>
      </div>
      <div className="CAS_Row">
        <div className="CAS_Column">
          <div>
            <h2>Student Data</h2>
            <GridWrapper
              eid={"CAS_Studata_Summary"}
              sproc="sputilities.webui.Comply_studata_summary"
              params={["@PRID", loaderData.ident.toUpperCase()]}
              Callouts={false}
              URLParams={""}
              NoneMessage="No student or applicant records found for this person. Check identifier and try again"
            ></GridWrapper>
          </div>
          <div>
            <h2>Current or Most Recent Course</h2>
            <GridWrapper
              eid={"CAS_CourseDetails_Summary"}
              sproc="sputilities.webui.Comply_studata_courseDetails"
              params={["@PRID", loaderData.ident]}
              Callouts={false}
              URLParams={""}
              NoneMessage="Not applicable to this student/applicant"
            ></GridWrapper>
          </div>
          <div className="JustASpacer"></div>
          <div>
            <GridWrapper
              eid={"CAS_ATAS_Banner"}
              sproc="sputilities.webui.COMPLY_studata_ATAS"
              params={["@PRID", loaderData.ident]}
              output="data"
              Callouts={false}
              URLParams={""}
              NoneMessage=""
            ></GridWrapper>
          </div>
          <Link
            className="CAS_Attendance_Button"
            to={"/compliance/Attendance/" + loaderData.ident}
            target="_blank"
          >
            Attendance Report
          </Link>

          <h2>Contact Address Archive</h2>
          <GridWrapper
            eid={"CAS_Address_Summary"}
            sproc="sputilities.webui.Comply_studata_AddressHistory"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
            limit={10}
          ></GridWrapper>
        </div>
        <div className="CAS_Column" id="stu_idents_summary">
          <h2>Student Identifiers</h2>
          <GridWrapper
            eid={"CAS_Studata_Summary"}
            sproc="sputilities.webui.Comply_list_all_idents"
            params={["@ident", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
          <h2>ESF Workflow History</h2>
          <GridWrapper
            eid={"CAS_Studata_Workflows"}
            sproc="sputilities.webui.COMPLIANCE_SUMMARY_Workflows"
            params={[
              "@IDENT",
              loaderData.ident,
              "@PREFIX",
              URL.includes("esf.essex")
                ? "https://forms.essex.ac.uk/"
                : "https://formstest.essex.ac.uk/",
            ]}
            Callouts={false}
            URLParams={""}
            NoneMessage="No workflows found for this student."
          ></GridWrapper>
        </div>
      </div>

      {/* <div className="CAS_Row">
        <div className="CAS_Column">
          <h2>
            Course Details Summary
          </h2>
          <GridWrapper
            eid={"CAS_CourseDetails_Summary"}
            sproc="sputilities.webui.Comply_studata_courseDetails"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
          ></GridWrapper>
        </div>
      </div> */}

      <div className="CAS_Row">
        <h1>Immigration Information</h1>
      </div>

      <div className="CAS_Row">
        <div className="CAS_Column">
          <h2>Immigration Information</h2>
          <GridWrapper
            eid={"CAS_Immigration_Summary"}
            sproc="sputilities.webui.Comply_studata_immigrationinfo"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>

        <div className="CAS_Column">
          <h2>Right to Study</h2>
          <GridWrapper
            eid={"CAS_RTS_Summary"}
            sproc="sputilities.webui.Comply_studata_RighttoStudy"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
      </div>

      <div className="CAS_Row">
        <div className="CAS_Column">
          <h2>Stay Permission</h2>
          <GridWrapper
            eid={"CAS_Immigration_Summary"}
            sproc="sputilities.webui.Comply_studata_StayPermission"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>

        <div className="CAS_Column">
          <h2>Digital Immigration</h2>
          <GridWrapper
            eid={"CAS_RTS_Summary"}
            sproc="sputilities.webui.Comply_studata_RecDigImmStatus"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
      </div>

      <div className="CAS_Row">
        <div className="CAS_Column">
          <h2>CAS History</h2>
          <GridWrapper
            eid={"CAS_Immigration_Summary"}
            sproc="sputilities.webui.Comply_studata_CASHistory"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
        <div className="CAS_Column"></div>
      </div>

      {/* <div className="CAS_Row">
        <div className="CAS_Column">
          <h2>
            Conditional Registrations
          </h2>
          <GridWrapper
            eid={"CAS_Immigration_Summary"}
            sproc="sputilities.webui.Comply_studata_ConditionalReg"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
      </div> */}

      <div className="CAS_Row">
        <div className="CAS_Column">
          <h2>Postgraduate Research Student Contact Monitoring</h2>
          <GridWrapper
            eid={"CAS_Immigration_Summary"}
            sproc="sputilities.webui.Comply_studata_PGR_RAG"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            limit={10}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
        <div className="CAS_Column"></div>
        {/* <div className="CAS_Column">
          <h2>
            Postgraduate Taught Student Contact Monitoring
          </h2>
          <div>
            <div className="ms-MessageBar ms-MessageBar-multiline no-results root-105">
              <div className="ms-MessageBar-content content-106">
                <div
                  className="ms-MessageBar-text text-109"
                  id="MessageBar414"
                  role="status"
                  aria-live="polite"
                >
                  <span className="ms-MessageBar-innerText innerText-110">
                    <span>&nbsp; This feature is not available yet</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>

      <div className="CAS_Row">
        <h1>Historic Information</h1>
      </div>

      <div className="CAS_Row">
        <div className="CAS_Column">
          <h2>Previous Registrations</h2>
          <GridWrapper
            eid={"CAS_Immigration_Summary"}
            sproc="sputilities.webui.Comply_studata_PrevCourse"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
      </div>

      <div className="CAS_Row">
        <h1>Admissions Information</h1>
      </div>

      <div className="CAS_Row">
        <div className="CAS_Column">
          <h2>Undergraduate Applications</h2>
          <GridWrapper
            eid={"CAS_Immigration_Summary"}
            sproc="sputilities.webui.Comply_studata_UGApp"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
        <div className="CAS_Column">
          <h2>Undergraduate Applications Residency Information</h2>
          <GridWrapper
            eid={"CAS_Immigration_Summary"}
            sproc="sputilities.webui.Comply_studata_UGAppResInf"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
      </div>

      <div className="CAS_Row">
        <div className="CAS_Column">
          <h2>Postgraduate Applications</h2>
          <GridWrapper
            eid={"CAS_Immigration_Summary"}
            sproc="sputilities.webui.Comply_studata_PGAPP"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
        <div className="CAS_Column">
          <h2>Postgraduate Applications Residency Information</h2>
          <GridWrapper
            eid={"CAS_Immigration_Summary"}
            sproc="sputilities.webui.Comply_studata_PGAppResInf"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
      </div>

      <div className="CAS_Row">
        <div className="CAS_Column">
          <h2>Other Applications</h2>
          <GridWrapper
            eid={"CAS_Immigration_Summary"}
            sproc="sputilities.webui.Comply_studata_OtherAPP"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
        <div className="CAS_Column">
          <h2>Other Applications Residency Information</h2>
          <GridWrapper
            eid={"CAS_Immigration_Summary"}
            sproc="sputilities.webui.Comply_studata_OtherAppResInf"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
      </div>

      <div className="CAS_Row">
        <div className="CAS_Column">
          <h2>Agent History</h2>
          <GridWrapper
            eid={"Agent_History"}
            sproc="sputilities.webui.Comply_studata_AgentHistory"
            params={["@PRID", loaderData.ident]}
            Callouts={false}
            URLParams={""}
            NoneMessage="Not applicable to this student/applicant"
          ></GridWrapper>
        </div>
      </div>

      <div className="CAS_Row">
        <div className="CAS_Column">
          <h2>Documents</h2>
          <div className="CAS_WarningBanner">
            <div className="CAS_WarningBanner_Title">WARNING</div>
            <div className="CAS_WarningBanner_Body">
              <p>
                If you are seeing this warning then there is a problem with
                SharePoint Online and you have been directed to our fallback
                page. The below results are being served from a local cache and
                as a result may be outdated.
              </p>
              <p>
                Additionally, in-browser file views will not work and files will
                need to be downloaded from SharePoint to view them
              </p>
            </div>
          </div>
          {cachedDocs.length == 0 ? (
            <MessageBar className="no-results">
              "No cached audit documents found for this person"
            </MessageBar>
          ) : (
            <GridContent
              eid="EDocs_Cached"
              items={cachedDocs}
              Logger={new Logging("LIVE")}
              gridindex={undefined}
              start={0}
              limit={200}
              showAdvancedSort={true}
              showAdvancedGrouping={true}
              showAdvancedFiltration={true}
              showCookieBouncer={true}
              Refresher=""
              Callouts={true}
              sort="Document_Type,Created_Date"
              group="Source_System"
            ></GridContent>
          )}
        </div>
      </div>
    </div>
  );
}
